import { api } from '../api';
import { SaveUserSetting } from '../model/settings/saveUserSetting';

export const settingsService = {
  getEnvironment,
  getUser,
  userSave,
};

function getEnvironment() {
  return api.get('/setting/all');
}

function getUser(accountGuid: string) {
  return api.get(`/setting/${accountGuid}`);
}

function userSave(
  accountId: string,
  settingName: string,
  settingValue: string
) {
  const request: SaveUserSetting = {
    AccountGuid: accountId,
    Name: settingName,
    Value: settingValue,
  };

  return api
    .post('/setting', request)
    .catch(() => {
      return getUser(accountId).then((settings: any) => {
        const setting = settings.find((s: any) => s.name === settingName);
        if (setting) {
          return updateUserSetting(
            setting.id,
            accountId,
            settingName,
            settingValue
          );
        }
      });
    });
}

function updateUserSetting(
  id: number,
  accountId: string,
  settingName: string,
  settingValue: string
) {
  const request = {
    Id: id,
    AccountGuid: accountId,
    Name: settingName,
    Value: settingValue,
  };

  return api.put('/setting', request);
}
